import { useMessageFormatter } from '@ci/formatters';
import m from './messages';

export const useIdNumberNameFormatter = () =>
	useMessageFormatter(
		name =>
			m[`idNumberName_${name}`] ?? { id: `myciUser.idNumberName_${name}`, defaultMessage: name }
	);
